<template>
  <v-table>
    <tbody>
      <tr>
        <td>
          {{ t('messages.version') }}
        </td>
        <td>
          <v-chip :color="versionColor" label size="small">
            {{ currentVersion }}
          </v-chip>
        </td>
      </tr>
      <template v-if="entity">
        <tr>
          <td>
            {{ t('messages.newestVersion') }}
          </td>
          <td>
            <v-chip label size="small">
              {{ entity.version }}
            </v-chip>
          </td>
        </tr>
        <tr>
          <td>
            {{ t('messages.buildTime') }}
          </td>
          <td>
            <v-chip v-tooltip:bottom="entity.buildTime" :append-icon="mdiClockOutline" label size="small">
              {{ format(entity.buildTime, { dateStyle: 'long', timeStyle: 'medium' }) }}
            </v-chip>
          </td>
        </tr>
      </template>
    </tbody>
  </v-table>
</template>

<script lang="ts" setup>
import { mdiClockOutline } from '@mdi/js';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import { useDateTimeFormatter } from '@abaninja/util-formatters';

import { useNewVersionAvailable } from './composables/useNewVersionAvailable';

const { currentVersion, entity } = useNewVersionAvailable();

const { t } = useI18n();

const { format } = useDateTimeFormatter();

const versionColor = computed(() => {
  if (!entity.value?.version) {
    return undefined;
  }

  return entity.value.version !== currentVersion ? 'error' : undefined;
});
</script>
